import { render, staticRenderFns } from "./LiveSetting.pug?vue&type=template&id=1c52c90c&lang=pug&"
import script from "./LiveSetting.vue?vue&type=script&lang=js&"
export * from "./LiveSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports